import $ from 'jquery';

/**
 * When the company is changed, update the list of systems to show the correct list.
 */
$(() =>
  $('form.edit_user #user_company_id').change(e => {
    const target = $(e.target);
    $.ajax(`../../systems/for_company/${target.val()}`, {
      success: data => {
        const $userSystemIds = $('#user_system_ids option:selected');
        const selectedIds = $userSystemIds.map((_, option) => option.value).get();
        $('#user_system_ids').html(data);
        $userSystemIds.prop('selected', false);
        selectedIds.forEach(v =>
          $('#user_system_ids option[value="' + v + '"]').prop('selected', true));
      }
    });
  }).trigger('change')
);
